import { LanguageConfig } from '@entities/language/model/types';

export const AR_LOCALE = 'ar';
export const EN_LOCALE = 'en';

export const EN_lang: LanguageConfig = {
  lang: 'en',
  name: 'English',
  direction: 'ltr',
  checkData: false,
};

export const AR_lang: LanguageConfig = {
  lang: AR_LOCALE,
  name: 'العربية',
  direction: 'rtl',
  checkData: false,
};

export const FR_lang: LanguageConfig = {
  lang: 'fr',
  name: 'Français',
  direction: 'ltr',
  checkData: false,
};

export const ES_lang: LanguageConfig = {
  lang: 'es',
  name: 'Español',
  direction: 'ltr',
  checkData: false,
};

export const PT_lang: LanguageConfig = {
  lang: 'pt',
  name: 'Português',
  direction: 'ltr',
  checkData: false,
};

export const TR_lang: LanguageConfig = {
  lang: 'tr',
  name: 'Türkçe',
  direction: 'ltr',
  checkData: false,
};

export const KR_lang: LanguageConfig = {
  lang: 'kr',
  name: 'کوردی',
  direction: 'rtl',
  checkData: false,
};

export const CORE_LANGUAGES: LanguageConfig[] = [EN_lang, AR_lang, FR_lang, ES_lang, PT_lang];

export const ADDITIONAL_LANGUAGES: LanguageConfig[] = [
  {
    lang: 'id',
    name: 'Indonesian',
    direction: 'ltr',
    country: 'ID',
  },
  {
    lang: 'ms',
    name: 'Malay',
    direction: 'ltr',
    country: 'MY',
  },
  {
    lang: 'tr',
    name: 'Türkçe',
    direction: 'ltr',
    country: 'TR',
  },
  {
    lang: 'no',
    name: 'Norwegian',
    direction: 'ltr',
    country: 'NO',
  },
  {
    lang: 'kr',
    name: 'کوردی',
    direction: 'rtl',
    country: 'IQ',
  },
];

export const ALL_LANGUAGES: LanguageConfig[] = [...CORE_LANGUAGES, ...ADDITIONAL_LANGUAGES];

export const LANGUAGE_NAMES = ['en', 'ar', 'fr', 'es', 'pt', 'tr', 'id', 'ms', 'ur', 'no', 'kr'];

export const SPECIAL_LANGUAGES_FOR_INPUT_FIELDS = [...LANGUAGE_NAMES, 'headerenrichment'];

export const LEGACY_ERROR_MESSAGES = {
  en_invalid_cars: 'Invalid card details or insufficient funds',
  ar_invalid_cars: 'معلومات البطاقة غير صحيحة أو لا يوجد رصيد كاف ',
  en_email_subscribed: 'This email is already subscribed',
  ar_email_subscribed: 'هذا البريد الإلكتروني مشترك',
};

// Backward compatibility exports
export const arLocale = AR_LOCALE;
export const EN_LANG = EN_lang;
export const AR_LANG = AR_lang;
export const FR_LANG = FR_lang;
export const ES_LANG = ES_lang;
export const PT_LANG = PT_lang;
export const TR_LANG = TR_lang;
export const KR_LANG = KR_lang;
export const languagesNames = LANGUAGE_NAMES;

// Default export for backward compatibility
const languages = CORE_LANGUAGES;
export default languages;
